module.exports = __webpack_public_path__ + "img/ban_1.2370dae1.png";